// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"9f888704","393":"f1f5c716","423":"6035c8b4","431":"85550fd9","535":"c53ad71f","668":"5e50698e"}[chunkId] + ".chunk.js";
};